<template>
    <div class="about__section">
        <h3>ProPoint Agent</h3>
        <dl>
            <dt>Agent Info</dt>
            <dd>
                <button class="btn btn-default btn-sm"
                        :class="{active: showAgentInfo}"
                        @click="toggleShowAgentInfo()">
                    Show Info
                </button>
            </dd>

            <dt>Connect Agent</dt>
            <dd>
                <button class="btn btn-default btn-sm"
                        @click="connectToAgent()">
                    Connect
                </button>
            </dd>
        </dl>
    </div>
</template>

<script>
import { container } from '@/container';

export default {
    name: 'DebugAgentSection',

    data() {
        return {
            showAgentInfo: container.$rootScope.showAgentInfo,
        };
    },

    methods: {
        toggleShowAgentInfo() {
            container.$timeout(() => {
                container.$rootScope.showAgentInfo = !container.$rootScope.showAgentInfo;
                this.showAgentInfo = container.$rootScope.showAgentInfo;
            });
        },

        connectToAgent() {
            container.agentService.connectToAgent();
        },
    },
};
</script>
